import truncate from 'lodash/truncate'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { toggleFavourite } from '../../favourites.js'
import { checkEventIsFavourited, useFavourites } from '../hooks/useFavourites.js'
import { EventType } from '../types'

export const EventCell = ({ event, rowHeight }) => {
  const favourites = useFavourites()
  const isFavourited = useMemo(() => checkEventIsFavourited(favourites, event.id), [favourites, event.id])
  const title = event.short_title || event.title
  return (
    <li key={event.id} style={{ height: rowHeight }}>
      <a href={event.url} title={title}>
        {truncate(title, { length: 56 })}
      </a>
      <svg width="16" height="16" style={{ cursor: 'pointer' }} onClick={() => toggleFavourite(event.id, event.title)}>
        <use xlinkHref={`/assets/glyphs/glyphs.svg?cachebust=2024#${isFavourited ? 'heart2' : 'heart2-outline'}`} />
      </svg>
    </li>
  )
}
EventCell.propTypes = {
  rowHeight: PropTypes.number.isRequired,
  event: EventType,
}
